import component from './HotelPricePolicy';

export default component;
